const monthMapper = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];

const doubler = ( value ) => (value + '').length > 1 ? value: '0' + value ; 


const getDisplayTime = (time, formatter = ( ...args ) => ( [ ...args ] ) ) => {

    if( isNaN( Number( time ) ) ) { 
        console.warn( "Invalid Time difference in date.js displayTime()" );
        time = 0;
    }
    time = Number( time );
    let ss = parseInt( time % 60 );
    let mm = parseInt( ( time / 60 ) % 60);
    let hh = parseInt( ( time / (60 * 60) ) % 24);

    let args = [ hh, mm, ss ].map( digit => doubler( digit ) );

    return formatter( ...args );
}


/**  
 * @param { instance of Date } dateInstance 
 * @returns { String } @format 'mmm dd';
*/

const getViewDate = ( dateInstance ) => {
    if( !( dateInstance instanceof Date ) ) return '';

    const date = dateInstance.getDate();

    const monthIndex = dateInstance.getMonth();
    const month = monthMapper[ monthIndex ] ;
    const year = dateInstance.getFullYear();

    return `${ date } ${ month } ${ year }`;
    
}


/**
 * 
 * @param { String } string: string value to create date:
 * @returns @var { Instance of Date} date if valid or @instance of Date with current time. 
 */
const getDate = ( string = '' ) => {
    string = string.replace?.( /-/g,'/');
    const date = new Date( string );
    return isNaN( date.getTime() ) ? new Date() : date ;
}


/**
 * 
 * @param { instance of Date } date
 * @returns string format 'yyyy-mm-dd hh:mm' 
 */
const getDateString = ( paramDate , timeRequired = false ) => {
    if( !( paramDate instanceof Date ) )return '';
    const date = {
        year : paramDate.getFullYear(),
        month : paramDate.getMonth() + 1 ,
        day : paramDate.getDate(),
        hours : paramDate.getHours(),
        minutes : paramDate.getMinutes(),
    }
    for( let prop in date ){
        date[ prop ] = doubler( date[ prop ] );
    }

    return `${ date.year }-${ date.month }-${ date.day }` + ( timeRequired ? `${ date.hours }:${ date.minutes }`: '' ) ;
}

const getLeftTime = ( { starttime, totalduration } ) =>{
    if( !starttime || !totalduration ) return  ;

    const lockTime = new Date( ( starttime + totalduration ) * 1000 );

    return  lockTime.getTime() - new Date().getTime();
}

export {
    getDate,
    getDateString,
    getViewDate,
    getLeftTime,
    getDisplayTime
}